import { useQuery } from "@tanstack/react-query";
import { getCallAnalysisOverview } from "@/app/actions/call/overview/action";
import { CallScopeFilter } from "@/app/types/call/CallScopeFilter";
import { UCallScope } from "@/app/utils/UCallScope";
import { QueryKey } from "@/app/vars/QueryKeys";

export function useFetchCallAnalysisOverview(
  projectId?: number,
  filter: CallScopeFilter = {},
  enabled: boolean = true,
) {
  return useQuery({
    queryKey: [QueryKey.CALL_ANALYSIS_OVERVIEW, projectId, ...UCallScope.queryKey(filter)],
    queryFn: () => getCallAnalysisOverview(projectId!, filter),
    enabled: enabled && !!projectId,
    staleTime: Infinity,
  });
}
